import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'JDYun 活動システム',
  system_demo: 'システムデモ',
  confirm: '確認',
  cancel: 'キャンセル',
  show: '表示',
  hide: '非表示',
  open: '開く',
  close: '閉じる',
  save: '保存',
  edit: '編集',
  delete: '削除',
  add: '追加',
  search: '検索',
  query: 'クエリ',
  reset: 'リセット',
  submit: '送信',
  upload: 'アップロード',
  download: 'ダウンロード',
  export: 'エクスポート',
  import: 'インポート',

  started: '開始済み',
  ended: '終了済み',
  next: '次へ',
  prev: '前へ',
  publish: '公開',
  input: '{text}を入力してください',
  select: '{text}を選択してください',
  total: '合計 {total}',
  price: '{price} 円',
  required: '{text}は必須です',
  selected: '{total}件の{text}が選択されました',
  create: '作成',
  free: '無料',
  charge: '有料',
  default: 'デフォルト',
  custom: 'カスタム',
  max: '最大',
  min: '最小',
  percent: 'パーセント',
  online: 'オンライン',
  offline: 'オフライン',
  name: '名前',
  remark: '備考',
  tips: 'ヒント',
  header: {
    logout: 'ログアウト',
    binding: 'アカウント連携',
    mobile: 'モバイル商人クライアント',
    register: 'モバイルクライアント',
    tips: '活動 {name}',
    qrcodeText: '{name} H5 QRコード',
    qrcodeMiniText: '{name} アプレットコード',
    qrcode: 'QRコードをダウンロードするにはクリックしてください',
    qrcodeMini: 'アプレットコードをダウンロードするにはクリックしてください'
  },
  home: {
    title: 'Jindouyun活動管理プラットフォームへようこそ',
    sub_title: '最も完全で詳細な活動と会議イベントをここで公開しましょう',
    desc: '活動管理から活動主催の旅を始めましょう',
    create: '素早く活動を作成'
  },
  user: {
    title: 'アカウント基本情報',
    logo: 'ブランドロゴ',
    update: '更新',
    name: '会社または組織名',
    short_name: '左上メニューバーのブランド',
    enable: 'パーソナライズドログインを有効にする',
    web_tips: 'パーソナライズドログインURL',
    copy: 'URLをコピー',
    login: 'ログインページのブランド名',
    login_title: 'ログインページのシステム名'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // CODE_SUCCESS: 2000,
  2000: '操作が成功しました',
  // CODE_ERROR: 5000,
  5000: 'ネットワークリクエストに失敗しました。ネットワークを確認してください',
  // CODE_ERROR_PARAMS: 5001,
  5001: 'リクエストパラメータエラー',
  // URL注册失败
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'URL登録に失敗しました',
  // CODE_ERROR_NO_PARAM: 5003,
  5003: 'パラメータエラー',
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: '権限エラー',
  // JWT 验证错误
  // CODE_JWT_ERROR: 5100,
  5100: 'JWT検証に失敗しました',
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: 'ログインに失敗しました',
  // JWT Token 无效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWTが無効です',
  // CODE_JWT_NO_USER: 5103,
  5103: 'ユーザーが存在しません',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'sizeパラメータエラー',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'pageパラメータエラー',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: '検索キーワードエラー'
}



// WEBPACK FOOTER //
// ./src/langs/ja/index.js